.cardHeaderWrapper {
  background-color: var(--ogm-title-bg-color-1);
  width: 100%;
}

.cardHeaderInnerWrapper {
  margin: auto;
  max-width: var(--ogm-max-width);
  padding: 12px 16px;
  color: var(--ogm-title-color-1);
  font-family: var(--ogm-font-family-1);
}
@media (min-width: 1024px) {
  .cardHeaderInnerWrapper {
    padding: 16px;
  }
}

.breadcrumbIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 9px;
  height: 9px;
}

.cardEventLinkWrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  padding: unset;
}
@media (min-width: 768px) {
  .cardEventLinkWrapper {
    padding: 15px 0 0;
  }
}
@media (min-width: 1024px) {
  .cardEventLinkWrapper {
    padding: 15px 0 0;
  }
}
.cardEventLinkWrapper:hover {
  cursor: pointer;
}

a.cardEventLink {
  position: relative;
  color: inherit;
  text-decoration: none;
  font-size: 15px;
  font-family: var(--ogm-font-family-2);
}
@media (min-width: 768px) {
  a.cardEventLink {
    font-size: 15px;
  }
}

.cardHeaderContentContainer {
  margin-top: 8px;
}
@media (min-width: 768px) {
  .cardHeaderContentContainer {
    display: flex;
    align-items: center;
    margin: 20px 0 15px;
    justify-content: space-between;
  }
}
@media (min-width: 1024px) {
  .cardHeaderContentContainer {
    position: sticky;
    top: 55px;
    right: 0;
    left: 0;
    z-index: var(--cxy-z-index-above-ad);
  }
}

.cardHeaderTextWrapper {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  z-index: var(--cxy-z-index-internal-base);
  margin-bottom: 8px;
}
.cardHeaderTextWrapper h1 {
  color: var(--ogm-title-color-1);
  font-family: var(--ogm-font-family-1);
  font-size: 32px;
  font-weight: 700;
}
@media (max-width: 1023px) {
  .cardHeaderTextWrapper h1 {
    font-size: 18px;
  }
}
@media (min-width: 1024px) {
  .cardHeaderTextWrapper {
    margin-bottom: unset;
  }
}
.cardHeaderTextWrapper .dropdownTitleWrapper {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: #fff;
}
.cardHeaderTextWrapper .dropdownTitle {
  color: var(--ogm-black);
  font-family: var(--ogm-font-family-1);
}
